import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { getColor } from '../../V2/Elements/Icons/helpers';
const Svg = styled.svg `
  ${({ type }) => type === 'pause' &&
    css `
      transform: rotate(90deg);
    `}
`;
const Icon = React.forwardRef(function Icon({ size = 24, alt, color, className, onClick, type }, ref) {
    const theme = useTheme();
    const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
    return (_jsxs(Svg, { ref: ref, onClick: onClick, width: size, height: size, viewBox: '0 0 24 24', fill: 'none', className: className, type: type, children: [_jsx("rect", { x: '5', y: '14', width: '14', height: '2', fill: fillColor }), _jsx("rect", { x: '5', y: '8', width: '14', height: '2', fill: fillColor })] }));
});
export default React.memo(Icon);
